import React from 'react';
import { PatternFormat } from 'react-number-format';

/**
 * @param maskPattern A string with the mask pattern you want to use. Example:
 * @param customInput If you want to render a custom input component, you can pass it in here. `<input` renders by default
 * @example
 * // If we want to mask the input on a FormTextField component
 * const MaskedComponent = MaskedInput('(###) ###-####', FormTextField);
 * // Redux Form Field
 * <Field component={MaskedComponent} />
 */
export const MaskedInput =
  (maskPattern: string, customInput: any = null) =>
  ({ input, ...props }: any) =>
    (
      <PatternFormat
        customInput={customInput}
        format={maskPattern}
        mask=" "
        onValueChange={({ value }) => {
          input.onChange(value);
        }}
        {...input}
        {...props}
      />
    );
